// generated from 570 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const firstPurchaseSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("first_purchase_since_filter"),
  comparison_key: z.enum([
    "3", // 295 (51.75%)
    "4", // 152 (26.67%)
    "6", // 91 (15.96%)
    "5", // 32 (5.61%)
  ]),
  display_name: z.string(),
  // undefined: 148 (25.96%), defined 422 (74.04%)
  raw_value: z
    .union([
      // number samples: 179 (42.42%)
      // integer: 170 (94.97%)
      // avg: 65.37, min: 0, max: 732
      z.number().min(0),
      // string samples: 243 (57.58%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 243 (42.63%)
    // integer: 234 (96.30%)
    // avg: 55.70, min: 0, max: 732
    z.number().min(0),
    // string samples: 327 (57.37%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
